import { COOKIES } from './constants';

export const getCookie = (key: string): string | undefined => {
	if (typeof document === 'undefined') {
		return undefined;
	}

	return (
		document.cookie
			.split('; ')
			.find((row) => row.startsWith(`${key}=`))
			?.split('=')[1] || undefined
	);
};

type SetSessionCookieOptions = {
	path?: string;
	sameSite?: 'Lax' | 'Strict' | 'None';
	secure?: boolean;
};

export function setSessionCookie(
	name: string,
	value: string,
	options: SetSessionCookieOptions = {
		path: '/',
		sameSite: 'Strict',
		secure: true
	}
): void {
	if (typeof document === 'undefined') return;

	const { path, sameSite, secure } = options;

	let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
	cookie += `; path=${path}`;
	cookie += `; SameSite=${sameSite}`;

	if (secure) cookie += '; Secure';

	document.cookie = cookie;
}

export const deleteCookie = (name: string): void => {
	if (typeof document !== 'undefined') {
		document.cookie =
			name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	}
};

export const multicityEnabled = (): boolean => {
	return getCookie(COOKIES.MULTICITY) === '1';
};
